<ng-container>
    <i title="archive" (click)="delete($event)" class="fa fa-2x fa-fw fa-trash icon-main"></i>
</ng-container>
